module.exports = __webpack_public_path__ + "static/media/usermanagement.2519e0e4.png";